import template from './mx-quick-link.html';
import { EventCodes } from '../../../../App/model/event-codes';

/**
 * @ngdoc component
 * @name mx.agent:mxQuickLink
 * @module mx.agent
 * @description Displays quick link for quick starts
 * @param {string} label@ - Optional. Label of the control.
 * @param {string} entityType@ - Entity type
 * @param {string} linkType@ - enumeration: 'new', 'preview', 'list'
 * @param {string} objectId@ - id of the object for object details
 */
angular.module('mx.SolutionBuilderAgent').component('mxQuickLink', {
	bindings: {
		title: '@',
		titleNeutral: '@',
		icon: '@',
		entityType: '@',
		objectId: '@',
		entityClassName: '@',
		entityId: '@',
		editObject: '@',
		previewObject: '@',
		readonlyObject: '<?',
		fullscreen: '@',
		fullWidth: '@',
		description: '@',
		externalLink: '@',
		navigationItem: '@',
		filter: '@',
		action: '@',
		actionContext: '<?',
		linkType: '@',
		sourceState: '@',
		showLoading: '@',
		source: '@',
		landingPage: '@',
		datasetView: '@',
		backgroundColor: '<',
		darkerHoveredBackground: '@',
		iconColor: '<',
		textColor: '<',
		viewType: '@',
		isSingleView: '<?',
		mode: '@',
		viewHideActions: '<',
		hideUnavailable: '@',
		detectSmallSize: '@',
		reactOnContainerClick: '<',
		assignDestination: '=?',
		assignSource: '=?',
		assignBeforeSource: '=?',
		assignBeforeDestination: '=?',
		disabled: '<',
		disableOnActionSubmit: '<',
		outerContext: '<',
		confirmationMessage: '@',
		reloadOnActionSubmit: '<',
		notificationOnSubmit: '@',
		closeOnSubmit: '<',
		reloadDatasetOnSubmit: '<',
	},
	require: {
		mxServiceContext: '?^^mxServiceContext',
		parentViewController: '?^^mxView',
		mxContainerCtrl: '?^^mxContainer',
	},
	controller: MxQuickLinkCtrl,
	controllerAs: 'vm',
	template: template,
});

MxQuickLinkCtrl.$inject = [
	'$scope',
	'$element',
	'$timeout',
	'$window',
	'$state',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.shell.SidePanelService',
	'mx.shell.RoutingService',
	'mx.shell.ActionExecutorService',
	'mx.shell.ActionManagerService',
	'mx.shell.NavigationService',
	'mx.SolutionBuilderAgent.DataModelService',
	'mx.shell.AppsService',
	'mx.SolutionBuilderAgent.EntityService',
	'mx.shell.EventService',
	'mx.shell.NotificationService',
	'mx.internationalization',
	'mx.shell.Config',
	'mx.shell.NavigationItemsLoaderService',
	'mx.SolutionBuilderAgent.WidgetManager',
	'mx.SolutionBuilderAgent.SearchQueryService',
];

function MxQuickLinkCtrl(
	$scope,
	$element,
	$timeout,
	$window,
	$state,
	dialogOpener,
	sidePanelService,
	routingService,
	actionExecutorService,
	actionManagerService,
	navigationService,
	dataModelService,
	appsService,
	mxEntityService,
	eventService,
	notificationService,
	i18n,
	mxConfig,
	navigationItemsLoaderService,
	widgetManager,
	searchQueryService
) {
	const vm = this;
	let linkType;

	vm.$onInit = function () {
		vm.isSmallLink = false;
		vm.isHoverActive = vm.darkerHoveredBackground === 'true';
		vm.isButton = typeof vm.mode === 'undefined' || vm.mode === 'button';
		vm.isLink = vm.mode === 'link';
		vm.alwaysVisible = vm.hideUnavailable !== 'true';
		vm.view = vm.mxServiceContext ? vm.mxServiceContext.mxServiceContext : undefined;
		vm.title = vm.title ? vm.title : '';

		if (vm.mxContainerCtrl) {
			vm.mxContainerCtrl.registerChild($scope);
		}

		let hasRules;
		Object.defineProperty(vm, 'hasRules', {
			get: function () {
				return hasRules;
			},
			set: function (newValue) {
				if (hasRules !== newValue) {
					hasRules = newValue;
					if (hasRules) {
						$element.removeClass('no-rules');
					} else if (!vm.alwaysVisible) {
						$element.addClass('no-rules');
					}
				}
			},
		});
		vm.hasRules = false;

		if ((vm.fullWidth || 'true').toLowerCase() === 'true') {
			$element.addClass('full-width');
		}

		if (vm.isButton && vm.detectSmallSize === 'true') {
			var _smallSizeHandler = $.debounce(500, function () {
				if (!$element.is(':visible')) {
					return;
				}
				var width = $element.width();
				if (!width) {
					_smallSizeHandler();
					return;
				}
				$scope.$evalAsync(function () {
					vm.isSmallLink = width <= 200;
				});
			});
			eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, _smallSizeHandler, $scope);
			eventService.subscribeTo('editingM42DashboardFinished', _smallSizeHandler, $scope);
			_smallSizeHandler();
		}

		linkType = vm.linkType;

		if (!linkType) {
			if (vm.entityType) {
				linkType = 'object';
			} else if (vm.navigationItem) {
				linkType = 'navigation';
			} else if (vm.externalLink) {
				linkType = 'external';
			} else if (vm.action) {
				linkType = 'action';
			}
		}

		vm.loadingState = {
			Loading: 1,
			Default: 2,
		};

		vm.assignBefore = function () {
			vm.assignBeforeDestination = vm.assignBeforeSource;
		};

		switch (linkType) {
			case 'object':
				initDialogButton();
				break;
			case 'navigation':
				initNavigation();
				break;
			case 'external':
				initExternal();
				break;
			case 'action':
				initAction();
				break;
			case 'callservice':
				initCallServiceButton();
				break;
			case 'landingpage':
				initLandingPageButton();
				break;
			case 'assign':
				initAssignButton();
				break;
			case 'datasetview':
				initDatasetViewButton();
				break;
		}
	};

	vm.$postLink = function () {
		if (vm.reactOnContainerClick) {
			$element
				.closest('.root-cell')
				.addClass('mx-root-cell--clickable')
				.on('click', (event) => {
					if (!$(event.target).is('a[href],[ng-click]')) {
						$element.find('.mx-quick-link-button').click();
					}
				});
		}
	};

	vm.$onChanges = function (changes) {
		if (changes.icon) {
			var icon = changes.icon.currentValue;
			if (icon) {
				vm.iconType = icon.indexOf('/') === -1 ? 'icon' : 'image';

				if (vm.iconType === 'icon' && icon.indexOf(':') > -1) {
					vm.iconType = 'svg_icon';
				}
			} else {
				vm.iconType = 'none';
			}
		}

		if (linkType === 'object') {
			if (changes.entityType) {
				checkDialogRules();
			}

			if (changes.entityClassName || changes.entityId) {
				if (vm.entityClassName && vm.entityId) {
					initDialogWithClassNameAndId();
				}
			}
		}
	};

	vm.onClick = async function (event) {
		if (event && event.stopPropagation) {
			event.stopPropagation();
		}

		eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: 'Quick link clicked',
			senderTitle: vm.titleNeutral,
		});

		let cancelled = false;
		if (vm.confirmationMessage) {
			try {
				await notificationService.confirm(
					vm.title,
					vm.confirmationMessage,
					i18n.get('solutionBuilderAgent.common.ok_btn'),
					i18n.get('solutionBuilderAgent.common.cancel_btn')
				);
			} catch (e) {
				cancelled = true;
			}
		}

		if (cancelled) {
			return;
		}

		vm.assignBefore();
		try {
			if (typeof vm.mainAction === 'function') {
				await vm.mainAction();
			}
		} catch (e) {
			mx.logCatch(e);
		}
		afterSubmit();
	};

	function afterSubmit() {
		var currentView = sidePanelService.getSidePanelView(vm.parentViewController && vm.parentViewController.mxView);

		if (vm.disableOnActionSubmit) {
			vm.disabled = true;
		}

		if (vm.reloadOnActionSubmit) {
			if (currentView) {
				sidePanelService.refreshView(currentView);
			}
		}

		if (vm.reloadDatasetOnSubmit) {
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SearchPageDataChanged, { instantRefresh: true });
		}

		if (vm.notificationOnSubmit) {
			notificationService.info(vm.notificationOnSubmit);
		}

		if (vm.closeOnSubmit) {
			if (currentView) {
				sidePanelService.closeView(currentView);
			}
		}
	}

	function initAssignButton() {
		vm.hasRules = true;
		vm.mainAction = function () {
			vm.assignDestination = vm.assignSource;
		};
		//onClick is set from XSLT transformation in ControlDescriptor
	}

	function initLandingPageButton() {
		vm.hasRules = true;
		vm.mainAction = function () {
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ReloadLandingPage, vm.landingPage);
		};
	}

	function initDatasetViewButton() {
		const currentApp = appsService.getCurrentApplication();
		const appString = currentApp.name;
		vm.hasRules = Boolean(vm.datasetView);

		vm.mainAction = async function () {
			await $state.go(
				'customDataSet',
				{
					appString: appString,
					contentWidgetId: vm.datasetView,
					filterId: vm.filter,
					filterType: vm.filter ? 'filter' : 'nofilter',
					viewType: !isNaN(vm.viewType) ? Number(vm.viewType) : null,
				},
				{ location: false }
			);

			navigationService.setExtraItem(vm.title);
		};
	}

	async function initCallServiceButton() {
		const dataModel = await vm.mxServiceContext?.$dataModelPromise;
		if (!dataModel || !dataModel.Context) {
			return;
		}

		$scope.$watch('vm.sourceState', function () {
			if (sourceStateIs(mx.SolutionBuilderAgent.SourceLoadingStatus.LOADED) || sourceStateIs(mx.SolutionBuilderAgent.SourceLoadingStatus.REJECTED)) {
				$timeout(function () {
					vm.state = vm.loadingState.Default;
				}, 400);
			} else if (sourceStateIs(mx.SolutionBuilderAgent.SourceLoadingStatus.LOADING)) {
				vm.state = vm.loadingState.Loading;
			}
		});

		vm.hasRules = true;

		vm.mainAction = async function () {
			if (vm.state !== vm.loadingState.Loading) {
				await dataModelService.reloadSourceByPath(vm.source, dataModel, dataModel.Context.WidgetId);
			}
		};
	}

	async function initNavigation() {
		if (!vm.navigationItem) {
			return;
		}
		let navigationItem, extraFilter;

		if (vm.filter) {
			navigationItem = await navigationService.getNavigationItem(vm.filter);
		}

		if (!navigationItem || navigationItem.parameters.navigationId !== vm.navigationItem) {
			navigationItem = await navigationService.getNavigationItem(vm.navigationItem);
		}

		if (navigationItem) {
			vm.hasRules = true;

			if (vm.filter && navigationItem.dataQuery && navigationItem.contentWidgetId) {
				if (navigationItem.parameters.filterId !== vm.filter) {
					extraFilter = (await searchQueryService.getFilters(navigationItem.dataQuery, navigationItem.contentWidgetId)).find((filter) => filter.Id === vm.filter);
					if (!extraFilter) {
						notificationService.error('wrong extra filter');
					}
				}
			}

			vm.mainAction = async function () {
				await routingService.go(
					navigationItem.route,
					Object.assign({}, navigationItem.parameters, {
						extraFilter: extraFilter?.Id,
						viewType: vm.viewType && Number(vm.viewType),
					})
				);
			};
		} else {
			await initExternalAppNavigation();
		}
	}

	async function initExternalAppNavigation() {
		/* check if navigation item from other application */
		const navigationItem = await navigationItemsLoaderService.loadNavigationItem(vm.navigationItem);
		if (!navigationItem) {
			return;
		}
		vm.hasRules = true;

		const appString = (appsService.getApplications().find((app) => app.value === navigationItem.Application) || {}).name;

		vm.mainAction = function () {
			redirectToNavLink(navigationItem, appString);
		};
	}
	function redirectToNavLink(navigationItem, appString) {
		switch (navigationItem.ImplementationType) {
			case mx.SolutionBuilderAgent.NavigationItemImplementation.LandingPage:
				$window.open(`${mxConfig.settings.basePath}app-${appString}/landing-page/${navigationItem.Id}`, '_blank');
				break;
			case mx.SolutionBuilderAgent.NavigationItemImplementation.Default:
				if (navigationItem.Children?.length > 0) {
					redirectToNavLink(navigationItem.Children[0], appString);
				} else {
					$window.open(`${mxConfig.settings.basePath}app-${appString}/search-page/${navigationItem.Id}${vm.filter ? `/filter/${vm.filter}` : '/nofilter/'}`, '_blank');
				}
				break;
			default:
				$window.open(`${mxConfig.settings.basePath}app-${appString}/search-page/${navigationItem.Id}${vm.filter ? `/filter/${vm.filter}` : '/nofilter/'}`, '_blank');
				break;
		}
	}

	function checkDialogRules() {
		var promise;

		if (!vm.objectId) {
			vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.New;
			promise = widgetManager.getNewDialogs(vm.entityType);
		} else if (vm.editObject === 'true') {
			vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit;
			promise = widgetManager.getEditDialogs(vm.entityType);
		} else if (vm.previewObject === 'true') {
			promise = widgetManager.getPreviewsOrDialogs(vm.entityType).then(function (views) {
				if (Array.isArray(views) && views.length) {
					if (views.some(widgetManager.isPreview)) {
						vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview;
					} else if (views.some(widgetManager.isNewDialog)) {
						vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit;
					}
				}
				return views;
			});
		} else {
			vm.dialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview;
			promise = widgetManager.getViewsForPreview(vm.entityType).then(function (res) {
				return res.views;
			});
		}
		return promise.then(function (views) {
			vm.hasRules = views && views.length;
		});
	}

	function initDialogWithClassNameAndId() {
		vm.entityType = vm.objectId = undefined;
		mxEntityService.getFragmentDescriptorsInBatch(vm.entityClassName, vm.entityId).then(function (objDetails) {
			vm.entityType = (objDetails || {}).EntityType;
			vm.objectId = (objDetails || {}).ObjectId;
			checkDialogRules();
		});
	}

	function initDialogButton() {
		if (vm.entityClassName && vm.entityId) {
			initDialogWithClassNameAndId();
		} else {
			checkDialogRules();
		}

		vm.mainAction = async function () {
			if (!vm.entityType) {
				return;
			}

			switch (vm.dialogType) {
				case mx.SolutionBuilderAgent.ContentWidgetDialogAction.New:
					await dialogOpener.openNewDialog(
						vm.entityType,
						null,
						null,
						true,
						undefined,
						vm.parentViewController && vm.parentViewController.mxView,
						undefined,
						vm.outerContext
					).newEntityCreatedPromise;
					break;
				case mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit:
					var context = {
						_id: vm.objectId,
						_type: vm.entityType,
					};
					await dialogOpener.openEditDialog(context, vm.fullscreen === 'true', undefined, vm.parentViewController && vm.parentViewController.mxView, {
						outerContext: vm.outerContext,
						hideActions: Boolean(vm.viewHideActions),
						isSingleView: Boolean(vm.isSingleView),
						readOnly: vm.readonlyObject,
					}).finishDialogInteractionPromise;
					break;
				case mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview:
					await dialogOpener.openPreview(
						{
							EntityType: vm.entityType,
							Id: vm.objectId,
						},
						{
							outerContext: vm.outerContext,
							hideActions: Boolean(vm.viewHideActions),
							isSingleView: Boolean(vm.isSingleView),
							readOnly: vm.readonlyObject,
						},
						undefined,
						vm.parentViewController && vm.parentViewController.mxView
					);
			}
		};
	}

	function initExternal() {
		vm.hasRules = true;

		vm.mainAction = function () {
			window.open(vm.externalLink, '_blank');
		};
	}

	async function initAction() {
		const actions = await actionManagerService.getAllActions();
		if (!Array.isArray(actions)) {
			return;
		}
		const action = actions.find((action) => action.id === vm.action);

		if (!action) {
			return;
		}

		vm.hasRules = true;

		vm.mainAction = async function () {
			const context = Array.isArray(vm.actionContext) ? vm.actionContext : typeof vm.actionContext === 'undefined' ? undefined : [vm.actionContext];
			await actionExecutorService.execute(action, context, vm.parentViewController && vm.parentViewController.mxView);
		};
	}

	function sourceStateIs(value) {
		return Number(vm.sourceState) === value;
	}
}
